import React from 'react';
import { ArrowRight, Mail } from 'lucide-react';
export function ComplianceNewsletterSection() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-56">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-57">
        <div className="bg-[#F8FAFC] rounded-[40px] p-10 md:p-16 flex flex-col lg:flex-row items-center justify-between gap-12" data-id="element-58">
          <div className="max-w-xl" data-id="element-59">
            <h2 className="text-3xl font-bold text-[#0A1628] mb-4" data-id="element-60">
              Stay informed with new products.
            </h2>
            <p className="text-slate-500 text-lg" data-id="element-61">
              Receive quarterly updates on industrial labelling standards,
              material innovations, and regulatory changes. No spam, just
              insight.
            </p>
          </div>

          <div className="w-full max-w-md" data-id="element-62">
            <div className="relative" data-id="element-63">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-64" />
              <input type="email" placeholder="Enter your work email" className="w-full pl-12 pr-36 py-4 bg-white border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#0052CC]/20 focus:border-[#0052CC] transition-all" data-id="element-65" />
              <button className="absolute right-1.5 top-1.5 bottom-1.5 px-6 bg-[#0A1628] text-white font-bold rounded-full hover:bg-[#0052CC] transition-colors flex items-center" data-id="element-66">
                Subscribe
              </button>
            </div>
            <p className="text-xs text-slate-400 mt-4 pl-4" data-id="element-67">
              Join 5,000+ industry professionals. Unsubscribe anytime.
            </p>
          </div>
        </div>
      </div>
    </section>;
}